import { PropertiesType } from './types';

export const PROPERTIES: PropertiesType = {
    column: 'horizontal',
    row: 'vertical',
    'column-reverse': 'horizontal',
    'row-reverse': 'vertical',
};
